import React from "react";

import { NextPage } from "next";
import dynamic from "next/dynamic";
import Head from "next/head";

import Layout from "@/components/layouts/layout/Layout";
import { BestChefsSection } from "@/components/sections/chefs/best-chefs/BestChefsSection";
import { GallerySection } from "@/components/sections/chefs/gallery/GallerySection";
import { JoinCommunitySection } from "@/components/sections/chefs/join-community/JoinCommunitySection";
import { useMediaQuery, useTheme } from "@mui/material";

const NewChefsSection = dynamic(
  () =>
    import("@/components/sections/chefs/new-chefs/NewChefsSection").then(
      mod => mod.NewChefsSection
    ),
  {
    loading: () => <section />
  }
);

export const ChefsPage: NextPage = (props: any): JSX.Element => {
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Layout noFooter={!isGreaterThanTablet}>
      <Head>
        <meta name="theme-color" content={theme.palette.primary.main} />
      </Head>
      <GallerySection />
      <BestChefsSection />
      <JoinCommunitySection />
      <NewChefsSection />
    </Layout>
  );
};
